import Model, { attr, belongsTo } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';

import type LocationModel from './location';

export default class LocationRole extends Model {
  declare [Type]: 'location-role';

  @belongsTo('location', { async: false, inverse: null })
  declare location: LocationModel;

  @attr('string')
  declare roleName: string;

  @attr('date')
  declare confirmedAt: Date;
}
